//
// client-exceptions-stack-trace-modal.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').directive('clientExceptionsStackTraceModal', () => ({
        restrict: 'E',
        transclude: true,
        templateUrl: '/templates/partials/client-exceptions-stack-trace-modal.html',

        controller: ['$rootScope', '$scope', 'ClientExceptionsService', ($rootScope, $scope, ClientExceptionsService) => {
            $scope.model = {
                stackTrace: null,
                targetId: null,
            };
        }],

        link(scope, element, attrs) {
            const reset = () => {
                scope.model.stackTrace = null;
            };

            scope.closeModal = () => {
                reset();
                element.modal('hide');
            };

            scope.model.targetId = attrs.targetId;
        },
    }));
}))();
